import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { GetCollaboratersDto } from "../../../../core/models/task-management/getCollaboratersDto";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { AccordionModule } from "primeng/accordion";
import { CommonModule } from "@angular/common";
import { CardModule } from "primeng/card";
import { SpinnerComponent } from "../../spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-collaborators",
  templateUrl: "./collaborators.component.html",
  styleUrls: ["./collaborators.component.scss"],
  imports: [AccordionModule, CommonModule, CardModule, SpinnerComponent],
})
export class CollaboratorsComponent implements OnInit {
  display = false;
  showSmallLoader = true;
  showUpcomingSmallLoader = true;
  collaborators: GetCollaboratersDto[] = [];

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    this.getCollaboratersList();
  }

  getCollaboratersList() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getCollaboratersList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.collaborators = res.data || [];
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }
}
